import { IGeneric } from "./interfaces/generic.interface";
import { IPathway } from "./interfaces/modules.interface";

export const APP_CONFIGS = {
    key: "HRS",
    dev: false,
    title: "Prosperh HR",
    api: {
        base: "hr-supervisor"
    },
    analyticsId: "G-R1HVKBFB4E"
};

export const CONTENT_BASE_URL = process.env.REACT_APP_BASE_CONTENT_API_URL;

export const FORM_TYPE = {
    DSS: "DECISION_SUPPORT_SYSTEM"
};

export const DSS_SECTION = {
    MENTAL: "MENTAL_HEALTH",
    PHYSICAL: "PHYSICAL_HEALTH"
};

export const COOKIES = {
    TOKEN: "tk",
    TOKEN_EXP_HOURS: 2,
    REFRESH_TOKEN: "rtk",
    REFRESH_TOKEN_EXP_HOURS: 15 * 24,
    STRAPI_TOKEN: "stk",
    STRAPI_TOKEN_EXP_HOURS: 7 * 24,
    LANGUAGE: "lang"
};

export const LOCALE: IGeneric = {
    pt: "pt",
    en: "en",
    sq: "sq",
    hu: "hu-HU",
    es: "es",
    da: "da-DK",
    tr: "tr",
    nl: "nl",
    de: "de"
};

export const LOCALE_LABELS: IGeneric = {
    pt: "Português (PT)",
    en: "English (EN)",
    sq: "Shqip (SQ)",
    hu: "Magyar (HU)",
    es: "Español (SP)",
    da: "Dansk (DEN)",
    tr: "Türkçe (TR)",
    nl: "Dutch (NL)",
    de: "Deutsch (DE)"
};

export const DEFAULT_LANGUAGE = LOCALE.en;

export const PATHWAYS: IPathway = {
    0: "PATHWAY_1",
    1: "PATHWAY_1",
    2: "PATHWAY_2",
    3: "PATHWAY_3",
    4: "PATHWAY_4",
    5: "PATHWAY_5",
    6: "PATHWAY_6",
    7: "PATHWAY_7",
    8: "PATHWAY_8",
    9: "PATHWAY_9"
};
